// This file is AUTOGENERATED, do not edit it manually!!!

import { imageAnnotations as imageAnnotationsde } from './imageAnnotationsResx.de';
import { imageAnnotations as imageAnnotationsen } from './imageAnnotationsResx.en';
import { imageAnnotations as imageAnnotationsen_risk } from './imageAnnotationsResx.en_risk';
import { imageAnnotations as imageAnnotationses } from './imageAnnotationsResx.es';
import { imageAnnotations as imageAnnotationsfr } from './imageAnnotationsResx.fr';
import { imageAnnotations as imageAnnotationsit } from './imageAnnotationsResx.it';
import { imageAnnotations as imageAnnotationsnl } from './imageAnnotationsResx.nl';
import { imageAnnotations as imageAnnotationspl } from './imageAnnotationsResx.pl';
import { imageAnnotations as imageAnnotationspt } from './imageAnnotationsResx.pt';
import { imageAnnotations as imageAnnotationsru } from './imageAnnotationsResx.ru';
import { imageAnnotations as imageAnnotationssk } from './imageAnnotationsResx.sk';
import { imageAnnotations as imageAnnotationssv } from './imageAnnotationsResx.sv';
import { imageAnnotations as imageAnnotationstr } from './imageAnnotationsResx.tr';

const langMap: { [k: string]: Partial<typeof imageAnnotationsen> } = {
    de: imageAnnotationsde,
    en: imageAnnotationsen,
    en_risk: imageAnnotationsen_risk,
    es: imageAnnotationses,
    fr: imageAnnotationsfr,
    it: imageAnnotationsit,
    nl: imageAnnotationsnl,
    pl: imageAnnotationspl,
    pt: imageAnnotationspt,
    ru: imageAnnotationsru,
    sk: imageAnnotationssk,
    sv: imageAnnotationssv,
    tr: imageAnnotationstr,
};

/* tslint:disable: max-line-length */
export const imageAnnotationsResx = {
    get apply() {
        return langMap[ep.resxCulture].apply || langMap.en.apply;
    },
    get back() {
        return langMap[ep.resxCulture].back || langMap.en.back;
    },
    get cancel() {
        return langMap[ep.resxCulture].cancel || langMap.en.cancel;
    },
    get comment() {
        return langMap[ep.resxCulture].comment || langMap.en.comment;
    },
    get commented_on_image() {
        return langMap[ep.resxCulture].commented_on_image || langMap.en.commented_on_image;
    },
    get comments() {
        return langMap[ep.resxCulture].comments || langMap.en.comments;
    },
    get delete() {
        return langMap[ep.resxCulture].delete || langMap.en.delete;
    },
    get delete_comment() {
        return langMap[ep.resxCulture].delete_comment || langMap.en.delete_comment;
    },
    get deleted_image() {
        return langMap[ep.resxCulture].deleted_image || langMap.en.deleted_image;
    },
    get download() {
        return langMap[ep.resxCulture].download || langMap.en.download;
    },
    get edit() {
        return langMap[ep.resxCulture].edit || langMap.en.edit;
    },
    get no_comment() {
        return langMap[ep.resxCulture].no_comment || langMap.en.no_comment;
    },
    get write_comment() {
        return langMap[ep.resxCulture].write_comment || langMap.en.write_comment;
    },
};

// @ts-ignore
ep.resources = ep.resources || {};

// @ts-ignore
ep.resources.imageAnnotations = imageAnnotationsResx;
